import { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  Form,
  Label,
  Row,
  Nav,
  NavItem,
  NavLink,
  CardHeader,
  CardTitle,
  Button,
} from "reactstrap";
import "./styles.css";
import NavItems from "./NavItems";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const ImmigrationInfo = (props: any) => {
  const { t } = useTranslation();
  const [activeApplicationId, setActiveApplicationId] = useState<number | null>(null);

  const activeTabData =
    props?.data?.applications?.find((app: any) => app.id === props.activeApplicationId) ||
    props?.data?.applications?.[0];

  return (
    <Col lg="6" className="mb-4 mb-lg-0">
      <NavItems />
      <Card className="border-top-0 border-bottom-0 rounded-0 mb-0">
        <CardHeader>
          <CardTitle>
            <Link
              to={`/immigration/update-application/${props?.data?.id}/${props?.data?.immigration_id}/${activeTabData?.id}`}
              className="text-decoration-none"
            >
              Application ID #{activeTabData?.application_id || ""}
            </Link>
          </CardTitle>
        </CardHeader>

        <CardBody className="tab-content-body">
          <div className="tab-section">
            <div className="section-content">
              <div className="detail-row mb-4">
                <div className="detail-col">
                  <label className="label-text text-muted">Visa Type</label>
                  <p className="detail-value">
                    {activeTabData?.application_visa_type?.visa_type_value || ""}
                  </p>
                </div>

                <div className="detail-col">
                  <label className="label-text text-muted">Application Country</label>
                  <p className="detail-value">{activeTabData?.application_country?.name || ""}</p>
                </div>

                <div className="detail-col">
                  <label className="label-text text-muted">Submission Date</label>
                  <p className="detail-value">{activeTabData?.application_submission_date || ""}</p>
                </div>

                <div className="detail-col">
                  <label className="label-text text-muted">Status</label>
                  <p className="detail-value">
                    <span className="badge bg-success">
                      {activeTabData?.application_status?.application_status_value || ""}
                    </span>
                  </p>
                </div>
              </div>

              <div className="detail-row mb-4">
                <div className="detail-col">
                  <label className="label-text text-muted">Start date</label>
                  <p className="detail-value">{activeTabData?.application_start_date || ""}</p>
                </div>
                <div className="detail-col">
                  <label className="label-text text-muted">Expiry date</label>
                  <p className="detail-value">{activeTabData?.application_expiry_date || ""}</p>
                </div>
                <div className="detail-col">
                  <label className="label-text text-muted">Number of Entries</label>
                  <p className="detail-value">
                    <span className="badge bg-info">
                      {activeTabData?.number_of_entries?.number_of_entries_value || ""}
                    </span>
                  </p>
                </div>
              </div>

              <div className="renewal-alert mb-4">
                <div className="alert-badge">
                  Renewal due in {activeTabData?.application_duration || 0} days
                </div>
                <Link
                  className="btn btn-sm bg-warning text-white"
                  to={`/immigration/create-application/${props?.data?.id}/${props?.data?.immigration_id}`}
                >
                  Start renewal →
                </Link>
              </div>
            </div>

            <div className="documents-section">
              <h6 className="section-title">DOCUMENTS</h6>
              <div className="document-item">
                <div className="doc-name">Passport</div>
                <div className="doc-status verified">Verified</div>
              </div>
              <div className="document-item">
                <div className="doc-name">Visa copy</div>
                <div className="doc-status verified">Verified</div>
              </div>
              <div className="document-item">
                <div className="doc-name">Employment contract</div>
                <div className="doc-status verified">Pending</div>
              </div>
              <div className="document-item">
                <div className="doc-name">Residence permit</div>
                <div className="doc-status pending">Pending</div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ImmigrationInfo;
